import{b as $}from"./utils-BuG-uH50.js";const M=o=>{const c=new Set;return o.forEach(t=>{const n=(t.products?t.products[0]:t).custom,d=(n==null?void 0:n.product_sets_top)||[],i=(n==null?void 0:n.products_sets_bottom)||[];[...d,...i].forEach(e=>{e.id&&c.add(e.id)})}),[...c]},N=async o=>{var s,l;if(!o.length)return{};const c="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,[,a]=window.location.pathname.split("/"),d=((a||"").split("-")[1]||"gb").toUpperCase(),i=o.map(r=>`gid://shopify/Product/${r}`),e=`
    query GetSetProductPrices($ids: [ID!]!) @inContext(country: ${d}) {
      nodes(ids: $ids) {
        ... on Product {
          id
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;try{const h=await(await fetch(c,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:e,variables:{ids:i}})})).json(),u={};return(l=(s=h.data)==null?void 0:s.nodes)==null||l.forEach(p=>{if(p!=null&&p.id){const _=p.id.replace("gid://shopify/Product/","");u[_]=parseFloat(p.priceRange.minVariantPrice.amount)}}),u}catch(r){return console.error("Failed to fetch set product prices:",r),{}}},L=(o,c)=>{if(!c||!Object.keys(c).length)return null;const t=o.custom,a=(t==null?void 0:t.product_sets_top)||[],n=(t==null?void 0:t.products_sets_bottom)||[],d=[...a,...n];if(!d.length)return null;let i=1/0;return d.forEach(e=>{const s=c[e.id];s!==void 0&&s<i&&(i=s)}),i===1/0?null:i},R=(o,{isSlide:c=!1,index:t=99,setProductPrices:a={}}={})=>{var w,k,v,P,S,C,I,V,F,T,x,j;const{key:n,title:d,link:i,imageInfo:e,sellingPrice:s,listPrice:l,custom:r,ticket:h}=o,u=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",p=((P=(v=(k=(w=e==null?void 0:e.images)==null?void 0:w[0])==null?void 0:k.sources)==null?void 0:v[0])==null?void 0:P.url)||(e==null?void 0:e.thumbnail)||"",_=(s==null?void 0:s.min)||0,m=(l==null?void 0:l.min)>(s==null?void 0:s.min)?l.min:0,b=(C=(S=r==null?void 0:r.product_hover_image)==null?void 0:S[0])==null?void 0:C.label,f=(V=(I=r==null?void 0:r.colour_count)==null?void 0:I[0])==null?void 0:V.label,g=(T=(F=r==null?void 0:r.collaboration_name)==null?void 0:F[0])==null?void 0:T.label,z=t<=2?"eager":"lazy",E=t<=2?"high":"auto",y=((x=r==null?void 0:r.product_sets_top)==null?void 0:x.length)>0||((j=r==null?void 0:r.products_sets_bottom)==null?void 0:j.length)>0?L(o,a):null;return`
    <${c?"li":"div"}
      class="product-card ${c?"splide__slide":""}"
      data-voyado-product
      data-product-key="${n}"
      data-product-ticket="${h}"
    >
      ${A(r,_,m)}
      ${H(o)}
      <a
        href="${u}${i}"
        class="product-card__image-container ${b?"has-hover":""}"
        aria-label="${d}"
      >
        <img
          src="${p}"
          alt="Image of ${d}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${z}"
          fetchpriority="${E}"
        />
        ${b?`
          <img
            src="${b}"
            alt="Secondary image of ${d}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <div class="product-card__title-wrapper">
          <p class="product-card__title f1-lc">${d}</p>
          ${g?`<p class="product-card__collaboration f2-uc">${g}</p>`:""}
        </div>
        ${y!==null?O(y):q(_,m)}
      </div>
       <p
        data-product-id="${n}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${f&&f>1?`
        <p class="product-card__colour-count f2-lc">
          ${f} Colours
        </p>
      `:""}
    </${c?"li":"div"}>
  `},O=o=>`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">
        From ${$(o)}
      </span>
    </div>`,q=(o,c)=>{let t="",a="product-card__price--current";return c&&(t=`
      <span class="product-card__price--original f1-lc">
        ${$(c)}
      </span>
    `,a="product-card__price--discounted"),`
    <div class="product-card__price">
      ${t}
      <span class="${a} f1-lc">
        ${$(o)}
      </span>
    </div>`},A=(o,c,t)=>{if(c&&t&&c<t)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-c/t)*100)}% OFF
      </p>
    `;const a=d=>{var e,s;const i=(s=(e=o==null?void 0:o[d])==null?void 0:e[0])==null?void 0:s.label;return i&&!i.includes("-")?i:""},n=a("stock")||a("petite")||a("collection")||a("new")||a("back_in_stock")||a("available_to_rent")||a("nc_exclusive");return n?`
      <p class="product-card__label product-label product-label--default">
        ${n}
      </p>
    `:""},H=o=>{var t;const c=((t=o.link)==null?void 0:t.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${o.key}"
      data-product-handle="${c}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{R as b,M as c,N as f};
